<template>
  <b-container class="p-0">
    <b-row>
      <b-col cols="auto">
        <div  :style="model[prop] === '#ffffff' || model[prop] === '#FFFFFF'
        ? 'border-style: groove; border-width: 3px; ' + 'width: 25px; height: 25px; background-color: ' + model[prop] :
        'width: 25px; height: 25px; background-color: ' + model[prop]" :class="classOfColorBox">
        </div>
      </b-col>
      <b-col cols="auto" class="p-0">
        {{ model[prop] }}
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

export default {
  name: "ColorBoxClass",

  async created() {
  },

  mounted() {
    this.setClass();
  },

  methods: {

    setClass(){
      if(this.column.id){
        this.classOfColorBox = "mt-2";
      }
    }
  },

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
    classOfColorBox: ""
  })

};
</script>
